import { call, put, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  loginsSuccess,
  loginsFailure,
  loginSuccess,
  loginFailure,
  createLoginSuccess,
  createLoginFailure,
  updateLoginSuccess,
  updateLoginFailure,
  verifyLoginSuccess,
  verifyLoginFailure,
  deleteLoginSuccess,
  deleteLoginFailure,
} from './actions';
import {
  LOGINS_REQUEST,
  LOGIN_REQUEST,
  CREATE_LOGIN_REQUEST,
  UPDATE_LOGIN_REQUEST,
  VERIFY_LOGIN_REQUEST,
  DELETE_LOGIN_REQUEST,
} from './actionTypes';
import LoginService from '../../services/LoginService';

export function* getLoginsTask(action) {
  const params = action.payload;
  try {
    const list = yield call(LoginService.getLogins, params);
    yield put(loginsSuccess(list));
  } catch (error) {
    yield put(loginsFailure(error));
  }
}

export function* getLoginTask(action) {
  try {
    const loginId = action.payload;
    const login = yield call(LoginService.getLogin, loginId);
    yield put(loginSuccess(login));
  } catch (error) {
    yield put(loginFailure(error));
  }
}

export function* createLoginTask(action) {
  try {
    const params = action.payload;
    const login = yield call(LoginService.createLogin, params);
    yield put(createLoginSuccess(login));
    yield put(replace(`/${params.dealer_id}/crmlogins`));
  } catch (error) {
    yield put(createLoginFailure(error));
  }
}

export function* updateLoginTask(action) {
  try {
    const params = action.payload;
    const login = yield call(LoginService.updateLogin, params);
    yield put(updateLoginSuccess(login));
    yield put(replace(`/${params.dealer_id}/crmlogins`));
  } catch (error) {
    yield put(updateLoginFailure(error));
  }
}

export function* verifyLoginTask(action) {
  try {
    const { login, loginId } = action.payload;
    let verifyResult;
    // if the login id is provided, use that to verify
    if (loginId) {
      verifyResult = yield call(LoginService.verifyLoginById, loginId);
    } else {
      verifyResult = yield call(LoginService.verifyLogin, login);
    }
    yield put(verifyLoginSuccess(verifyResult));
  } catch (error) {
    if (error.status === 401) {
      yield put(verifyLoginSuccess(null));
    } else {
      yield put(verifyLoginFailure(error));
    }
  }
}

export function* deleteLoginTask(action) {
  try {
    const loginId = action.payload;
    yield call(LoginService.deleteLogin, loginId);
    yield put(deleteLoginSuccess(loginId));
  } catch (error) {
    yield put(deleteLoginFailure(error));
  }
}

export function* loginsSaga() {
  yield takeEvery(LOGINS_REQUEST, getLoginsTask);
  yield takeEvery(LOGIN_REQUEST, getLoginTask);
  yield takeEvery(CREATE_LOGIN_REQUEST, createLoginTask);
  yield takeEvery(UPDATE_LOGIN_REQUEST, updateLoginTask);
  yield takeEvery(VERIFY_LOGIN_REQUEST, verifyLoginTask);
  yield takeEvery(DELETE_LOGIN_REQUEST, deleteLoginTask);
}
